import { Routes } from '@angular/router';
import { WorkflowRepository, WorkflowService } from '@softapps/gewerbe/workflow';
import { AuthenticationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_CLAIM_REPORT } from './claim-report.shared';
import { ClaimReportCustomerRepository } from './repositories/claim-report-customer.repository';
import { ClaimReportSalesOrderRepository } from './repositories/claim-report-sales-order.repository';
import { ClaimReportDeviceRepository } from './repositories/claim-report-device.repository';
import { ComplaintRepository } from './repositories/complaint.repository';
import { ClaimReportCustomerService } from './services/claim-report-customer.service';
import { ClaimReportSalesOrderService } from './services/claim-report-sales-order.service';
import { ClaimReportDeviceService } from './services/claim-report-device.service';
import { ComplaintService } from './services/complaint.service';

export const claimReportRoutes: Routes = [
  {
    path: 'claim-report',
    canActivate: [AuthenticationGuard],
    data: { permission: SOFTLINE_PERMISSION_CLAIM_REPORT },
    providers: [
      // Route-scoped repositories and services go here.
    ],
    children: [
      { path: '', redirectTo: 'main', pathMatch: 'full' },
      {
        path: 'workflow/:id',
        providers: [WorkflowService, WorkflowRepository, ComplaintRepository],
        loadComponent: () => import('./pages/complaint-workflow/complaint-workflow'),
      },
      {
        path: 'main',
        providers: [
          ComplaintRepository,
          ComplaintService,
          ClaimReportCustomerRepository,
          ClaimReportCustomerService,
          ClaimReportSalesOrderRepository,
          ClaimReportSalesOrderService,
          ClaimReportDeviceRepository,
          ClaimReportDeviceService,
        ],
        loadComponent: () =>
          import('./pages/main/main.component').then(
            (m) => m.ClaimReportMainComponent
          ),
        children: [
          { path: '', redirectTo: 'customers', pathMatch: 'full' },
          {
            path: 'customers',
            data: { level: 'customers' },
            loadComponent: () =>
              import('./pages/list/list.component').then(
                (m) => m.ClaimReportListComponent
              ),
          },
          {
            path: 'customers/:customerId/documents',
            data: { level: 'documents' },
            loadComponent: () =>
              import('./pages/list/list.component').then(
                (m) => m.ClaimReportListComponent
              ),
          },
          {
            path: 'customers/:customerId/documents/:documentId/devices',
            data: { level: 'devices' },
            loadComponent: () =>
              import('./pages/list/list.component').then(
                (m) => m.ClaimReportListComponent
              ),
          },
        ],
      },
    ],
  },
];
